export default "__VITE_ASSET__vbh1AVjS__"